var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('language-change',{staticClass:"hidden-xs-only"}),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('my-footer',{staticClass:"hidden-xs-only"}),_c('my-footer2',{staticClass:"hidden-sm-and-up"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }